<template>
  <Dialog :visible="true" modal :style="{ width: '34rem' }" :breakpoints="{ '640px': '95vw' }" header="تعديل قسم دعوة لإجراء (CTA)" @update:visible="$emit('close')">
    <div class="ds-field-grid">
      <div class="form-field">
        <label class="field-label">الرمز</label>
        <input type="text" class="form-control" v-model="form.icon" />
      </div>
      <div class="form-field">
        <label class="field-label">العنوان</label>
        <input type="text" class="form-control" v-model="form.title" />
      </div>
    </div>
    <div class="form-field mt-2">
      <label class="field-label">العنوان الفرعي</label>
      <input type="text" class="form-control" v-model="form.subtitle" />
    </div>

    <div class="ds-field-grid mt-2">
      <div class="form-field">
        <label class="field-label">الزر الأساسي — النص</label>
        <input type="text" class="form-control" v-model="form.primary.label" />
      </div>
      <div class="form-field">
        <label class="field-label">الزر الأساسي — الرابط</label>
        <input type="text" class="form-control" dir="ltr" v-model="form.primary.link" />
      </div>
    </div>
    <div class="ds-field-grid mt-2">
      <div class="form-field">
        <label class="field-label">زر واتساب — النص</label>
        <input type="text" class="form-control" v-model="form.whatsapp.label" />
      </div>
      <div class="form-field">
        <label class="field-label">زر واتساب — الرابط</label>
        <input type="text" class="form-control" dir="ltr" v-model="form.whatsapp.url" />
      </div>
    </div>

    <div class="form-field mt-3 hb-visibility">
      <label class="field-label">الحالة</label>
      <InputSwitch v-model="form.is_active" />
    </div>

    <template #footer>
      <button class="btn-cancel" @click="$emit('close')">إلغاء</button>
      <button class="ds-btn ds-btn--primary" :disabled="store.saving" @click="save">
        <i class="pi pi-check"></i> {{ store.saving ? 'جارٍ الحفظ...' : 'حفظ' }}
      </button>
    </template>
  </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog';
import InputSwitch from 'primevue/inputswitch';
import Swal from 'sweetalert2';
import { useHomepageSectionStore } from '@/stores/useHomepageSectionStore.js';

export default {
  name: 'CtaEditor',
  components: { Dialog, InputSwitch },
  props: { section: { type: Object, required: true } },
  emits: ['close', 'saved'],
  data() {
    const s = this.section.settings || {};
    return {
      form: {
        icon: s.icon || '', title: s.title || '', subtitle: s.subtitle || '',
        primary: { label: s.primary?.label || '', link: s.primary?.link || '' },
        whatsapp: { label: s.whatsapp?.label || '', url: s.whatsapp?.url || '' },
        is_active: !!this.section.is_active,
      },
    };
  },
  computed: {
    store() { return useHomepageSectionStore(); },
  },
  methods: {
    async save() {
      try {
        await this.store.updateSection(this.section.id, {
          settings: {
            icon: this.form.icon, title: this.form.title, subtitle: this.form.subtitle,
            primary: { ...this.form.primary }, whatsapp: { ...this.form.whatsapp },
          },
          is_active: this.form.is_active,
        });
        Swal.fire({ icon: 'success', title: 'تم الحفظ', timer: 1400, showConfirmButton: false });
        this.$emit('saved');
      } catch (e) {
        Swal.fire({ icon: 'error', title: e?.response?.data?.message || 'حدث خطأ', timer: 2500, showConfirmButton: false });
      }
    },
  },
};
</script>

<style scoped>
.hb-visibility { display: flex; align-items: center; justify-content: space-between; }
</style>
